function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { filterMixin } from '@/mixins/filter_mixin';
import ProductizeUseCaseCreate from '@/apps/attributes/modules/use_cases/components/ProductizeUseCaseCreate.vue';
import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import ProductizeTransformedAttributeDetail from '@/apps/attributes/modules/use_cases/ProductizeTransformedAttributeDetail.vue';
import tasks from '@/js/tasks';
export default {
  name: 'ProductizeUseCase',
  components: {
    ProductizeUseCaseCreate: ProductizeUseCaseCreate,
    ProductizeTransformedAttributeDetail: ProductizeTransformedAttributeDetail
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      e1: 1,
      DIALOG_CREATE: 'DIALOG_CREATE',
      DIALOG_VIEW: 'DIALOG_VIEW',
      STATUS_ACTIVE: 13,
      STATUS_EXECUTE: 14,
      STATUS_ERROR: 2,
      filters: {
        text_filter: ''
      },
      headers: [{
        text: 'Caso de uso',
        value: 'caso_de_uso'
      }, {
        text: 'Segmento / Tabla',
        value: 'segmento'
      }, {
        text: 'Tipo exportación',
        value: 'tipo_exportacion'
      }, {
        text: 'Fecha Creación',
        value: 'fecha_creacion'
      }, {
        text: 'Fecha Actualización',
        value: 'fecha_actualizacion'
      }, {
        text: 'Carga única',
        value: 'carga_unica'
      }, {
        text: 'Frecuencia',
        value: 'frecuencia'
      }, {
        text: 'Día',
        value: 'dia'
      }, {
        text: 'Estado',
        value: 'estado'
      }, {
        text: '',
        value: 'action'
      }],
      // Datatable items
      items: [],
      modalOpen: false,
      selectedCase: {},
      selectedAttributesPending: [],
      group_productive_tables: [],
      table_detail: [],
      loading: false,
      selected: {}
    };
  },
  mounted: function mounted() {
    this.getHistory();
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('frases.productize_usecase'),
        disabled: true
      }];
    },
    getUseCaseStatus: function getUseCaseStatus() {
      var _this = this;
      return function (statusId) {
        var status = _this.labelCatalog.status_id[statusId.toString()].toUpperCase();
        var color = '';
        var textColor = 'white';
        switch (statusId) {
          case 1:
            color = 'warning';
            break;
          case 2:
            color = 'red';
            break;
          case 3:
            color = 'success';
            break;
          case 4:
            textColor = 'black';
            break;
          case 5:
            color = 'primary';
            break;
          case 7:
            color = 'error';
            break;
          case 10:
            color = '#B1B3B9';
            break;
          case 13:
            color = 'success';
            break;
          case 14:
            color = 'primary';
            break;
        }
        return {
          status: status,
          color: color,
          textColor: textColor
        };
      };
    },
    getTableStatus: function getTableStatus(status) {
      return function (statusId) {
        var color = '';
        var status = '';
        var textColor = 'white';
        switch (statusId) {
          case 'APPROVED':
            color = 'success';
            status = 'Aprobado';
            break;
          case 'REVISION':
            color = '#B1B3B9';
            status = 'Pendiente';
            break;
          case 'REJECTED':
            color = 'red';
            status = 'Rechazado';
            break;
          default:
            color = '#B1B3B9';
            status = '';
            break;
        }
        return {
          status: status,
          color: color,
          textColor: textColor
        };
      };
    }
  }),
  watch: {
    type_export_items: {
      immediate: true,
      handler: function handler(newVal) {
        if (this.isEditing && Array.isArray(newVal) && newVal.length && this.initialData && this.initialData.type_export_id != null) {
          var found = newVal.find(function (x) {
            return String(x.id) === String(this.initialData.type_export_id);
          }.bind(this));
          if (found) this.form.type_export = found;
        }
      }
    }
  },
  methods: {
    formatDate: function formatDate(dateString) {
      if (dateString) {
        var options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
      return '';
    },
    handleStepChange: function handleStepChange(newStep) {
      this.e1 = newStep;
      /*if (this.e1 === 4) {
        this.onCloseModal(this.DIALOG_CREATE)
        this.getHistory()
        this.e1 = 1
      }*/
    },
    onCloseCreate: function onCloseCreate(val) {
      this.onCloseModal(this.DIALOG_CREATE);
      this.getHistory();
      this.e1 = 1;
    },
    openDialog: function openDialog(modalName) {
      this.e1 = 1;
      this.$refs[modalName].onOpen();
    },
    onCloseModal: function onCloseModal(modalName) {
      this.$refs[modalName].onClose();
    },
    refreshClick: function refreshClick() {
      this.getHistory();
    },
    getHistory: function getHistory() {
      var _this2 = this;
      this.setShowLoading(true);
      var params = {
        user: window.userInfo.email
      };
      UseCasesService.getProductizeHistory({
        params: params
      }).then(function (response) {
        _this2.items = response.data.records;
        console.log(response.data.records, 'dataaaa');
        _this2.setShowLoading(false);
      });
    },
    crear: function crear() {
      console.log('crear');
    },
    openModal: function openModal(item) {
      this.modalOpen = true;
      this.selectedCase = item;
      this.selectedAttributesPending = item.pending_tables.map(function (table) {
        return {
          attributeValue: table.table_id,
          type_table: table.type_table,
          table_id: table.table_id,
          status: ''
        };
      });
    },
    closeModal: function closeModal() {
      this.modalOpen = false;
    },
    syncAttribute: function syncAttribute(attribute) {
      // Lógica para sincronizar un atributo
    },
    fetchAndCombineData: function () {
      var _fetchAndCombineData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var viewsData, params, response1, response2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              viewsData = [];
              params = {
                user: this.serviceAccount,
                sandbox: {
                  id: this.selectedCase.project_id,
                  technical_name: this.selectedCase.caso_de_uso
                }
              };
              _context.n = 1;
              return MyAccessService.getObjectAccess('productivize', params);
            case 1:
              response1 = _context.v;
              if (response1 && response1.data) {
                response1.data.forEach(function (element) {
                  viewsData.push({
                    text: element.table.id.replace(':', '.'),
                    value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
                    data: element,
                    status: 'APPROVED'
                  });
                });
              }
              _context.n = 2;
              return MyAccessService.getObjectAccessWithPending('productivize', params);
            case 2:
              response2 = _context.v;
              if (response2 && response2.data) {
                response2.data.forEach(function (element) {
                  viewsData.push({
                    text: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
                    value: element.tableReference.projectId + '.' + element.tableReference.datasetId + '.' + element.tableReference.tableId,
                    data: element,
                    status: 'REVISION'
                  });
                });
              }
              return _context.a(2, viewsData);
          }
        }, _callee, this);
      }));
      function fetchAndCombineData() {
        return _fetchAndCombineData.apply(this, arguments);
      }
      return fetchAndCombineData;
    }(),
    cleanAndPrioritizeData: function cleanAndPrioritizeData(viewsData) {
      var _this3 = this;
      // Inner function for prioritizing and adding items to viewsData
      var addItemToViewsData = function addItemToViewsData(item) {
        var existingIndex = viewsData.findIndex(function (existingItem) {
          return existingItem.text === item.text;
        });
        if (existingIndex !== -1) {
          if (item.status === 'REVISION' && viewsData[existingIndex].status === 'APPROVED') {
            viewsData[existingIndex] = item;
          }
        } else {
          viewsData.push(item);
        }
      };
      viewsData.forEach(addItemToViewsData);
      this.table_detail = [];
      this.selectedAttributesPending.forEach(function (attributeObj, index) {
        var table = viewsData.find(function (item) {
          return item.text === attributeObj.attributeValue && item.status === 'APPROVED';
        });
        if (table) {
          _this3.selectedAttributesPending[index].status = 'APPROVED';
          _this3.table_detail.push({
            type_table: attributeObj.type_table,
            view_id_replace: table.value,
            table_id: attributeObj.table_id,
            status_aprov: true
          });
        } else {
          _this3.selectedAttributesPending[index].status = 'REVISION';
          _this3.table_detail.push({
            type_table: attributeObj.type_table,
            view_id_replace: null,
            table_id: attributeObj.table_id,
            status_aprov: false
          });
        }
      });
      console.log(this.table_detail, 'table_detail');
    },
    postData: function () {
      var _postData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var enviar, datos, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              enviar = this.table_detail.some(function (item) {
                return item.status_aprov;
              });
              if (enviar) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              datos = {
                project_id: this.selectedCase.project_id,
                segment_id: this.selectedCase.segment_id,
                type_export_id: this.selectedCase.type_export_id,
                table_approved: this.table_detail
              };
              console.log(datos, 'datos');
              _context2.p = 2;
              _context2.n = 3;
              return UseCasesService.postExecuteApprovedAutomations(datos);
            case 3:
              response = _context2.v;
              if (response && response.data) {
                console.log(response);
                tasks.toast.success(this.translate('frases.successfully_registered'));
                this.closeModal();
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error('Error:', _t);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function postData() {
        return _postData.apply(this, arguments);
      }
      return postData;
    }(),
    syncAll: function () {
      var _syncAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var viewsData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              console.log('syncAll');
              this.loading = true;
              _context3.p = 1;
              _context3.n = 2;
              return this.fetchAndCombineData();
            case 2:
              viewsData = _context3.v;
              this.cleanAndPrioritizeData(viewsData);
              console.log(this.table_detail, 'table_detail final');
              _context3.n = 3;
              return this.postData();
            case 3:
              _context3.p = 3;
              this.setShowLoading(false);
              this.loading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function syncAll() {
        return _syncAll.apply(this, arguments);
      }
      return syncAll;
    }(),
    onExecuteAgain: function onExecuteAgain(item) {
      var _this4 = this;
      var body = {
        'project_id': item.project_id,
        'segment_id': item.segment_id,
        'type_export_id': item.type_export_id,
        'response_request': 'Execute again.',
        'operator': window.userInfo.email
      };
      UseCasesService.postApproveProductize(body).then(function (response) {
        _this4.setShowLoading(false);
        if (response.code === 200) {
          tasks.toast.success('Se esta ejecutando la exportanción.');
        } else {
          tasks.toast.error('No se ha podido ejecutar la exportación.');
        }
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
        _this4.setShowLoading(false);
      });
    },
    viewDetail: function viewDetail(item) {
      this.group_productive_tables = item.group_productive_tables;
      console.log(item);
      this.openDialog(this.DIALOG_VIEW);
    },
    viewDetailExport: function viewDetailExport(item) {
      this.selected = item;
      this.openDialog('DIALOG_DETAIL_EXPORT');
    },
    editFile: function editFile(item) {
      this.selected = item;
      this.e1 = 1;
      this.$refs['DIALOG_EDIT'].onOpen();
    },
    onCloseEdit: function onCloseEdit(val) {
      this.$refs['DIALOG_EDIT'].onClose();
      this.getHistory();
      this.e1 = 1;
    } // verifyTableStatus(attributeObj, index) {
    //   return new Promise((resolve, reject) => {
    //
    //     const params = {
    //       table_id: attributeObj.attributeValue
    //     }
    //     console.log(params)
    //     MyAccessService.postVerifyTableStatus('productivize', params).then(response => {
    //       if (response.data === null) {
    //         tasks.toast.info('No se encontró registros para la tabla ' + attributeObj.attributeValue)
    //       } else if (response && response.data && response.data.status) {
    //         console.log(response, 'response data')
    //         this.selectedAttributesPending[index].status = response.data.status
    //         if (this.selectedAttributesPending[index].status === 'APPROVED') {
    //           this.table_detail.push({
    //             type_table: this.selectedAttributesPending[index].type_table,
    //             table_id: this.selectedAttributesPending[index].table_id,
    //             status_aprov: true
    //           })
    //         } else if (this.selectedAttributesPending[index].status === 'REVISION') {
    //           this.table_detail.push({
    //             type_table: this.selectedAttributesPending[index].type_table,
    //             table_id: this.selectedAttributesPending[index].table_id,
    //             status_aprov: false
    //           })
    //         } else if (this.selectedAttributesPending[index].status === 'REJECTED') {
    //           this.table_detail.push({
    //             type_table: this.selectedAttributesPending[index].type_table,
    //             table_id: this.selectedAttributesPending[index].table_id,
    //             status_aprov: false
    //           })
    //           // tasks.toast.info(this.selectedAttributesPending[index].table_id + ': ' + this.translate('frases.rejected'))
    //         }
    //       }
    //       resolve()
    //     }).catch(error => {
    //       console.error(error)
    //       reject(error)
    //     })
    //   })
    // }
  }
};